const WARN_RATIO = 0.9;

const initializedTextareas = new WeakSet();

const toKilobytes = bytes => Math.round(bytes / 1024).toString();

const update = (textarea, warning) => {
    const maxBytes = parseInt(textarea.dataset.maxBytes, 10);
    const bytes    = new TextEncoder().encode(textarea.value).length;

    if (!maxBytes || bytes < maxBytes * WARN_RATIO) {
        warning.hidden = true;

        return;
    }

    warning.textContent = (warning.dataset.sizeWarningText ?? '')
        .replace('%used%', toKilobytes(bytes))
        .replace('%max%', toKilobytes(maxBytes));
    warning.classList.toggle('is-over', bytes > maxBytes);
    warning.hidden = false;
};

export const initializeContentSizeWarning = scope => {
    scope.querySelectorAll('textarea[data-max-bytes]').forEach(textarea => {
        if (initializedTextareas.has(textarea)) {
            return;
        }

        initializedTextareas.add(textarea);

        const warning = textarea.closest('.line-numbered-editor')?.parentElement?.querySelector('[data-content-size-warning]');

        if (!warning) {
            return;
        }

        const run = () => update(textarea, warning);

        textarea.addEventListener('input', run);
        run();
    });
};
